import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { FormHandles } from '@unform/core'
import { t } from 'i18next'

import { LoadingSection } from '~/components/LoadingSection'
import { useAppInfo } from '~/hooks/useAppInfo'
import useQueryParams from '~/hooks/useQuery'
import { usePanelSteps } from '~/modules/retailMedia/components/PanelSteps'
import SelectedProducts from '~/modules/retailMedia/components/SelectedProducts'
import { getProductsRecommended } from '~/modules/retailMedia/services/campaign-objective-based'
import { useAppSelector } from '~/store/hooks'

import { addProductsOnCampaign } from '../../../../../store/campaign/actions'

interface AutomaticallySelectedProductsProps {
  formRef: React.RefObject<FormHandles>
}

const AutomaticallySelectedProducts: React.FC<
  AutomaticallySelectedProductsProps
> = ({ formRef }) => {
  const dispatch = useDispatch()

  const { isWhiteLabel } = useAppInfo()
  const { selectedProducts } = useAppSelector(
    state => state.retailMedia.campaign.products
  )
  const rmid = useQueryParams().get('rmid')
  const [loading, setLoading] = useState(false)
  const { currentStep } = usePanelSteps()
  const [recommendedProductsQtd, setRecommendedProductsQtd] = useState(0)

  useEffect(() => {
    formRef.current?.setFieldValue('products', selectedProducts || [])
  }, [selectedProducts, formRef, currentStep])

  const handleRecommendedProducts = useCallback(() => {
    setLoading(true)
    getProductsRecommended(rmid)
      .then(response => {
        setTimeout(() => {
          const productsData = response?.data?.data?.map(item => ({
            ...item,
            isSuggested: true
          }))

          dispatch(addProductsOnCampaign({ products: productsData }))

          setRecommendedProductsQtd(productsData?.length || 0)

          setLoading(false)
        }, 500)
      })
      .catch(error => {
        console.error('Erro ao buscar produtos recomendados:', error)
        setLoading(false)
      })
  }, [dispatch, rmid])

  useEffect(() => {
    if (
      (rmid || isWhiteLabel) &&
      currentStep === 1 &&
      recommendedProductsQtd <= 0 &&
      !selectedProducts?.length
    ) {
      handleRecommendedProducts()
    }
  }, [
    handleRecommendedProducts,
    rmid,
    isWhiteLabel,
    currentStep,
    recommendedProductsQtd,
    selectedProducts?.length
  ])

  return (
    <>
      {loading && (
        <LoadingSection
          text={t('rm:objectiveBased.AutomaticallySelectedProducts.content')}
          padding="var(--sl-space-32)"
        />
      )}

      {!loading && (
        <SelectedProducts
          formRef={formRef}
          publisherId={rmid}
          onResetList={handleRecommendedProducts}
          recommendedProductsQtd={recommendedProductsQtd}
        />
      )}
    </>
  )
}

export default React.memo(AutomaticallySelectedProducts)
